import { Dashboard } from '@/pages/Dashboard'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$orgId/dashboard')({
  component: Dashboard,
  meta: () => [{ title: 'Dashboard' }],
})
